import React from 'react';
import { SearchPages } from 'src/store/common-slices/searchSlice';
import ChildContainersPage from 'src/components/pages/search-page/search-for-scanner/child-container-page/ChildContainersPageContainer';
import SearchedContainerPage from 'src/components/pages/search-page/search-for-scanner/searched-container-page/SearchedContainerPageContainer';
import Column from '@amzn/meridian/column';
import UILoader from 'src/components/common/loader/UILoaderContainer';
import StatusAlert from 'src/components/common/status-alert/StatusAlertContainer';

interface SearchForScannerStateProps {
    pageToRender: SearchPages
}

type Props = SearchForScannerStateProps;

/*
    On Scanner screen, when we search for a container, there are two screens:
    1 - On which the details of searched container will be rendered,
    2 - On which the details of child containers will be rendered.

    For example, if I searched a PALLET,
    On 1st screen, details of PALLET will be there.
    If user chooses to click on "View Totes" on that screen, 2nd screen comes up
    on which details of all the TOTEs inside that PALLET will be rendered.

    <SearchedContainerPage /> component is for 1st screen.
    <ChildContainersPage /> component is for 2nd screen.
*/
class SearchForScanner extends React.Component<Props, any> {
    public render() {
        return (
            <Column className="search-for-scanner">
                {this.props.pageToRender === SearchPages.SEARCHED_CONTAINER &&
                    <SearchedContainerPage />
                }
                <UILoader />
                <StatusAlert />
                {this.props.pageToRender === SearchPages.CHILD_CONTAINER &&
                    <ChildContainersPage />
                }
            </Column>
        );
    }
}

export default SearchForScanner;
